import React, { useEffect, useState } from 'react';
import './create-eval.styles.scss'

import CreateEvalForm from './create-eval-form.component'

const NewEval = () => {


	return (
		<div className='create-eval'>
			<div className='g-card'>
				<h3>Create a New Evaluation</h3><hr />
				<CreateEvalForm />
			</div>
		</div>
	)
}

export default NewEval;